var map = {
	"./radio_avaa.png": 6358,
	"./radio_farhang.png": 5522,
	"./radio_iran.png": 5965,
	"./radio_maaref.png": 1347,
	"./radio_quran.png": 5524,
	"./radio_salamat.png": 9084,
	"./radio_varzesh.png": 7612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7918;